import { render, staticRenderFns } from "./table-account.vue?vue&type=template&id=1b0810a8&scoped=true"
import script from "./table-account.vue?vue&type=script&lang=js"
export * from "./table-account.vue?vue&type=script&lang=js"
import style0 from "./table-account.vue?vue&type=style&index=0&id=1b0810a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0810a8",
  null
  
)

export default component.exports